import { useEffect, useState } from 'preact/hooks'
import { selectedValues } from 'snippets/plp-native/@store'
import TextInput from 'snippets/form/text-input/text-input'

function PlpNativeFilterPrice({ field, getLocalSelected }) {
  const priceRange = selectedValues?.value[field.field] || field?.range
  const [priceMin, setPriceMin] = useState(priceRange[0] || 0)
  const [priceMax, setPriceMax] = useState(priceRange[1] || 0)
  const [reRenderKey, setReRenderKey] = useState(0)
  const classWrap =
    "w-[calc(50%_-_15px)] relative before:content-['$'] before:block before:absolute before:left-3 before:top-[18px] before:z-5 before:text-xs before:text-neutral-900"

  const handleChangeInput = (priceValue, type) => {
    type === 'min' && setPriceMin(priceValue !== '' && +priceValue >= 0 ? +priceValue : 0)
    type === 'max' && setPriceMax(priceValue !== '' && +priceValue >= 0 ? +priceValue : 0)
    setReRenderKey(reRenderKey + 1)
  }

  useEffect(() => {
    const minPrice = priceMin !== '' && +priceMin >= 0 ? +priceMin : 0
    const maxPrice = priceMax !== '' && +priceMax >= 0 ? +priceMax : 0

    getLocalSelected(field.field, [minPrice, maxPrice], field.prefix)
  }, [priceMin, priceMax])

  return (
    <div className="flex items-center gap-3">
      <TextInput
        id="price-min"
        type="number"
        name="price-min"
        required={false}
        value={priceMin}
        placeholder="Min"
        labelInputClass="!leading-4"
        classWrap={classWrap}
        className="pl-[21px]"
        onInput={(e) => setPriceMin(e.target.value)}
        onBlur={(e) => handleChangeInput(e.target.value, 'min')}
        autocomplete
      />
      <div className="h-px w-1.5 bg-neutral-900" />
      <TextInput
        id="price-max"
        type="number"
        name="price-max"
        required={false}
        value={priceMax}
        placeholder="Max"
        labelInputClass="!leading-4"
        classWrap={classWrap}
        className="pl-[21px]"
        onInput={(e) => setPriceMax(e.target.value)}
        onBlur={(e) => handleChangeInput(e.target.value, 'max')}
        autocomplete
      />
    </div>
  )
}

export default PlpNativeFilterPrice
